import * as React from 'react';
import styled from 'styled-components';
import * as uuid from 'uuid';
import { DSFormHelperText } from '../../..';
import { DSFormControlProps, DSFormControl } from '../../../mui/FormControl';
import { DSInputLabel } from '../../../mui/Input/InputLabel';
import { DSOutlinedInputProps, DSOutlinedInput } from '../../../mui/Input/OutlinedInput';

const StyledInputLabel = styled(DSInputLabel)`
    position: relative;
    transform: none;
`;

export type OutlinedTextFieldProps = {
    InputProps?: DSOutlinedInputProps;
    error?: boolean;
    fullWidth?: boolean;
    helperText?: React.ReactNode;
    id?: string;
    innerRef?: DSFormControlProps['innerRef'];
    label?: React.ReactNode;
    margin?: DSFormControlProps['margin'];
    onChange?: DSOutlinedInputProps['onChange'];
    onClick?: DSOutlinedInputProps['onClick'];
    placeholder?: DSOutlinedInputProps['placeholder'];
    value?: DSOutlinedInputProps['value'];
};

export const OutlinedTextField = ({
    error,
    fullWidth,
    helperText,
    id,
    innerRef,
    InputProps,
    label,
    margin,
    onChange,
    onClick,
    placeholder,
    value,
}: OutlinedTextFieldProps): JSX.Element => {
    const formId = React.useMemo(() => id ?? uuid.v4(), [id]);
    return (
        <DSFormControl error={error} fullWidth={fullWidth} innerRef={innerRef} margin={margin}>
            <StyledInputLabel htmlFor={formId}>{label}</StyledInputLabel>
            <DSOutlinedInput
                {...InputProps}
                id={formId}
                margin="dense"
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                onClick={onClick}
            />
            {helperText && <DSFormHelperText>{helperText}</DSFormHelperText>}
        </DSFormControl>
    );
};

OutlinedTextField.displayName = 'OutlinedTextField';
